/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import Home from './views/Home';
import PresentationView from './views/Presentation';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import Uploads from './views/ReportKpis/components/Uploads/Uploads.js';
import Reports from './views/ReportKpis/components/Reports/Reports.js';
import TechAdd from './views/Scripts/components/TechAdd/TechAdd.js';
import Tickets from './views/Tickets/components/Tickets/Tickets.js';
import TicketDetails from './views/Tickets/components/TicketDetails/TicketDetails.js';
import Configuration from './views/CM/components/Configuration/Configuration';
import CellInfo from './views/CM/components/CellInfo/CellInfo';
import HuaweiRemoteAnalysis from './views/CM/components/HuaweiRemoteAnalysis/HuaweiRemoteAnalysis';
import ServiceIpAssignment from './views/IpAssignment/components/ServiceIpAssignment/ServiceIpAssignment';
import TransportIpAssignment from './views/IpAssignment/components/TransportIpAssignment/TransportIpAssignment';
import RemoveEBandIps from './views/IpAssignment/components/RemoveEBandIps/RemoveEBandIps';
import IpAudits from './views/IpAudits/components/IpAudits/IpAudits';
import SmallCells from './views/SmallCells/components/SmallCells';
import Scf from './views/Scripts/components/Scf/Scf';
import Downloads from './views/Downloads/Downloads';
import Report2CA from './views/Acceptance/components/Report2CA';
import ReportNR from './views/Acceptance/components/ReportNR';
import ReportNR7Assessment from './views/Acceptance/components/ReportNR7Assessment';
import RETEnablingChecks from './views/RanRETAudit/components/RETAudit_FileUpload/RetAudit';
import RETFilesUpload from './views/RanRETAudit/components/RETAudit_FileUpload/RETFilesUpload';
import IncidentTracker from './views/IncidentTracker/components/IncidentTracker/IncidentTracker';
import IncidentTrackerConfiguration from './views/IncidentTracker/components/IncidentTrackerConfiguration/IncidentTrackerConfiguration';
import SiteTracker from './views/SiteTracker/components/SiteTracker/SiteTracker';
import RANDumpExport from './views/RANDumpExport/components/RANDumpExport';
import CPMDumpExport from './views/RanRETAudit/components/CPMDumpExport';
import GEOFiles from './views/RanRETAudit/components/GEOInputFile';
import SiteAssessmentExport from './views/SiteAssessment7Days/components/SiteAssessment7Days';
import PerformanceMonitoring from './views/TopOffenders/components/TopOffendersExport';
import PerformanceMonitoringCities from './views/TopOffendersCities/components/TopOffendersCitiesExport';
import RanReportRFForm from './views/RanReportRF/components/RanReportRF';
import TopOffendersWorstSites from './views/TopOffendersWorstSites/components/WorstSitesExport';
import CapacityPRBBlackList from './views/CapacityPRBBlackList/components/CapacityPRBBlackListExport';
import TopOffendersWorstSitesCities from './views/TopOffendersWorstSites/components/WorstSitesCitiesExport';
import TopOffendersWorstSitesRegion from './views/TopOffendersWorstSites/components/WorstSitesRegionExport';
import BwUpdate from './views/Scripts/components/BwUpdate/BwUpdate';
import TopOffendersAggSite from './views/TopOffendersGenericReports/components/TopOffendersAggSiteReport';
import ReportRFCounters from './views/Acceptance/components/ReportRFCounters';
import TopOffendersAggSubRegion from './views/TopOffendersGenericReports/components/TopOffendersAggSubRegionReport';
import TopOffendersAggRegion from './views/TopOffendersGenericReports/components/TopOffendersAggRegionReport';
import TopOffendersAggCity from './views/TopOffendersGenericReports/components/TopOffendersAggCityReport';
import IncidentTrackerDemo from './views/RFOPTTracker/components/IncidentTracker';
import ReportSunset from './views/Acceptance/components/ReportSunset';
import FocusOccasionEventsUpload from './views/FocusOccasion/components/FocusOccasionUpload';
import AcceptanceManagement from './views/AcceptanceManagement/components/AcceptanceManagement';
import IncidentCellList from './views/IncidentCellList/components/IncidentCellList';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Home(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/DynamicClusters',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/inspect/:id',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: DashboardInspect(props)
								}),
							},
							{
								path: '/dashboards/inspect/:id',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: DashboardInspect(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/RFOPTTracker',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/RFOPTTracker',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: IncidentTrackerDemo()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/dashboards',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/inspect/:id',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: DashboardInspect(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/NetworkPerformanceMonitoring',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/NetworkPerformanceMonitoring/HardySubRegions',
								exact: true,
								component: (props) => AuthGuard({
									children: PerformanceMonitoring()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/WorstSites',
								exact: true,
								component: (props) => AuthGuard({
									children: TopOffendersWorstSites()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/HardyCities',
								exact: true,
								component: (props) => AuthGuard({
									children: PerformanceMonitoringCities()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/CapacityPRBBlackList',
								exact: true,
								component: (props) => AuthGuard({
									children: CapacityPRBBlackList()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/WorstSitesCities',
								exact: true,
								component: (props) => AuthGuard({
									children: TopOffendersWorstSitesCities()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/WorstSitesRegion',
								exact: true,
								component: (props) => AuthGuard({
									children: TopOffendersWorstSitesRegion()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/TopOffendersAggSite',
								exact: true,
								component: (props) => AuthGuard({
									children: TopOffendersAggSite()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/TopOffendersAggSubRegion',
								exact: true,
								component: (props) => AuthGuard({
									children: TopOffendersAggSubRegion()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/TopOffendersAggRegion',
								exact: true,
								component: (props) => AuthGuard({
									children: TopOffendersAggRegion()
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/TopOffendersAggCity',
								exact: true,
								component: (props) => AuthGuard({
									children: TopOffendersAggCity()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	}, /* ,
	{
		path: '/NetworkPerformanceMonitoring/HardyCities',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/NetworkPerformanceMonitoring/HardyCities',
								exact: true,
								component: (props) => AuthGuard({
									children: PerformanceMonitoringCities()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	} */
	{
		path: '/smallcells',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/smallcells/reports',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: SmallCells()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/acceptance',
		component: () => AuthGuard({
			// roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/acceptance/management',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									children: AcceptanceManagement()
								}),
							},
							{
								path: '/acceptance/reports/2ca',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									children: Report2CA()
								}),
							},
							{
								path: '/acceptance/reports/nr',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									children: ReportNR()
								}),
							},
							{
								path: '/acceptance/reports/rf',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									children: RanReportRFForm()
								}),
							},
							{
								path: '/acceptance/reports/nrBulkAssessment',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									children: ReportNR7Assessment()
								}),
							},
							{
								path: '/acceptance/reports/sunset',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									children: ReportSunset()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/acceptanceTools',
		component: () => AuthGuard({
			// roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/acceptanceTools/reports/nrBulkAssessment',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									children: ReportNR7Assessment()
								}),
							},
							{
								path: '/acceptanceTools/reports/nr_cbo',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									children: Reports()
								}),
							},
							{
								path: '/acceptanceTools/reports/dumpsExport',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									children: RANDumpExport()
								}),
							},
							{
								path: '/acceptanceTools/reports/sitePowerBoost',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									children: SiteAssessmentExport()
								}),
							},
							{
								path: '/acceptanceTools/reports/reportRFCounters',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									children: ReportRFCounters()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/focusOccasion',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/FocusOccasion/EventsUpload',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: FocusOccasionEventsUpload()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/retaudit',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/retaudit/retfilesupload',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: RETFilesUpload()
								}),
							},
							{
								path: '/retaudit/retenablingchecks',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									children: RETEnablingChecks()
								}),
							},
							{
								path: '/retaudit/CPMDumps',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: CPMDumpExport()
								}),
							},
							{
								path: '/retaudit/GEOinput',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: GEOFiles()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/onDemandReport',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/onDemandReport/retEnablingChecks',
								exact: true,
								component: (props) => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
									children: RETEnablingChecks()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/kpis',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			// operator: ['Vodafone', ...]
			projects: ['Operations', 'Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/kpis/uploads',
								exact: true,
								component: () => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Uploads()
								}),
							},
							{
								path: '/kpis/reports',
								exact: true,
								component: () => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Reports()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/scripts',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			// operator: ['Vodafone', ...]
			projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						// eslint-disable-next-line no-sparse-arrays
						routes: [
							{
								path: '/scripts/techadd',
								exact: true,
								component: () => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: TechAdd()
								}),
							},
							{
								path: '/scripts/scf',
								exact: true,
								component: () => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Scf()
								}),
							}, ,
							{
								path: '/scripts/bwupdate',
								exact: true,
								component: () => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: BwUpdate()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/cm',
		component: () => AuthGuard({
			// operator: ['Vodafone', ...]
			projects: ['Operations', 'Ran'],
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/cm/configuration',
								exact: true,
								component: () => AuthGuard({
									children: Configuration()
								}),
							},
							{
								path: '/cm/cellinfo',
								exact: true,
								component: () => AuthGuard({
									children: CellInfo()
								}),
							},
							{
								path: '/cm/huaweiRemoteAnalysis',
								exact: true,
								component: () => AuthGuard({
									children: HuaweiRemoteAnalysis()
								}),
							},
							{
								path: '/cm/incidentcelllist',
								exact: true,
								component: () => AuthGuard({
									children: IncidentCellList()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/ipassignment',
		component: () => AuthGuard({
			// operator: ['Vodafone', ...]
			projects: ['Core'],
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/ipassignment/serviceipassignment',
								exact: true,
								component: () => AuthGuard({
									children: ServiceIpAssignment()
								}),
							},
							{
								path: '/ipassignment/transportipassignment',
								exact: true,
								component: () => AuthGuard({
									children: TransportIpAssignment()
								}),
							},
							{
								path: '/ipassignment/removeebandips',
								exact: true,
								component: () => AuthGuard({
									children: RemoveEBandIps()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/ipaudits',
		exact: true,
		component: () => AuthGuard({
			// operator: ['Vodafone', ...]
			projects: ['Core'],
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: () => AuthGuard({
									children: IpAudits()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/incidenttracker',
		component: () => AuthGuard({
			// operator: ['Vodafone', ...]
			projects: ['Operations'],
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/incidenttracker/incidenttracker',
								exact: true,
								component: () => AuthGuard({
									children: IncidentTracker()
								}),
							},
							{
								path: '/incidenttracker/incidenttrackerconfiguration',
								exact: true,
								component: () => AuthGuard({
									children: IncidentTrackerConfiguration()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/sitetracker',
		component: () => AuthGuard({
			// operator: ['Vodafone', ...]
			projects: ['Operations'],
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/sitetracker/sitetracker',
								exact: true,
								component: () => AuthGuard({
									children: SiteTracker()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/tickets',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			// operator: ['Vodafone', ...]
			projects: ['Operations', 'Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/tickets',
								exact: true,
								component: () => AuthGuard({
									children: Tickets()
								}),
							},
							{
								path: '/tickets/details/:id',
								exact: true,
								component: (props) => AuthGuard({
									children: TicketDetails(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/downloads',
		exact: true,
		component: () => AuthGuard({
			roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Downloads(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								path: '/management/statistics',
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: DashboardLayout(
										{
											route: {
												routes: [
													{
														path: '/dashboards/inspect/:id',
														exact: true,
														component: (props) => AuthGuard({
															// : ['Administrator', 'Manager'],
															children: DashboardInspect(props)
														}),
													},
													{
														component: () => <Redirect to="/errors/error-404" />,
													},
												],
											}
										}
									)
								}),
							},
							{
								path: '/management/dataintegrity',
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
									children: DashboardLayout(
										{
											route: {
												routes: [
													{
														path: '/dashboards/inspect/:id',
														exact: true,
														component: (props) => AuthGuard({
															// : ['Administrator', 'Manager'],
															children: DashboardInspect(props)
														}),
													},
													{
														path: '/dashboards/inspect/:id',
														exact: true,
														component: (props) => AuthGuard({
															// : ['Administrator', 'Manager'],
															children: DashboardInspect(props)
														}),
													},
													{
														component: () => <Redirect to="/errors/error-404" />,
													},
												],
											}
										}
									)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),

	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},

	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '*',
		component: () => AuthGuard({
			roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout({
				route: {
					routes: [
						{
							path: '/notifications',
							exact: true,
							component: lazy(() => import('views/Notifications')),
						},
						{
							path: '/calendar',
							exact: true,
							component: lazy(() => import('views/Calendar')),
						},
						{
							path: '/changelog',
							exact: true,
							component: lazy(() => import('views/Changelog')),
						},
						{
							path: '/chat',
							exact: true,
							component: lazy(() => import('views/Chat')),
						},
						{
							path: '/chat/:id',
							exact: true,
							component: lazy(() => import('views/Chat')),
						},
						{
							path: '/dashboard/analytics',
							exact: true,
							component: DashboardAnalyticsView,
						},
						{
							path: '/dashboard/default',
							exact: true,
							component: DashboardDefaultView,
						},
						{
							path: '/invoices/:id',
							exact: true,
							component: lazy(() => import('views/InvoiceDetails')),
						},
						{
							path: '/kanban-board',
							exact: true,
							component: lazy(() => import('views/KanbanBoard')),
						},
						{
							path: '/mail',
							exact: true,
							component: lazy(() => import('views/Mail')),
						},
						{
							path: '/manage/customers',
							exact: true,
							component: lazy(() => import('views/CustomerManagementList')),
						},
						{
							path: '/manage/customers/:id',
							exact: true,
							component: lazy(() => import('views/CustomerManagementDetails')
							),
						},
						{
							path: '/manage/customers/:id/:tab',
							exact: true,
							component: lazy(() => import('views/CustomerManagementDetails')
							),
						},
						{
							path: '/manage/projects',
							exact: true,
							component: lazy(() => import('views/ProjectManagementList')),
						},
						{
							path: '/manage/orders',
							exact: true,
							component: lazy(() => import('views/OrderManagementList')),
						},
						{
							path: '/manage/orders/:id',
							exact: true,
							component: lazy(() => import('views/OrderManagementDetails')),
						},
						{
							path: '/overview',
							exact: true,
							component: OverviewView,
						},
						{
							path: '/presentation',
							exact: true,
							component: PresentationView,
						},
						{
							path: '/profile/:id',
							exact: true,
							component: lazy(() => import('views/Profile')),
						},
						{
							path: '/profile/:id/:tab',
							exact: true,
							component: lazy(() => import('views/Profile')),
						},
						{
							path: '/projects/create',
							exact: true,
							component: lazy(() => import('views/ProjectCreate')),
						},
						{
							path: '/projects/:id',
							exact: true,
							component: lazy(() => import('views/ProjectDetails')),
						},
						{
							path: '/projects/:id/:tab',
							exact: true,
							component: lazy(() => import('views/ProjectDetails')),
						},
						{
							path: '/projects',
							exact: true,
							component: lazy(() => import('views/ProjectList')),
						},
						{
							path: '/settings',
							exact: true,
							component: lazy(() => import('views/Settings')),
						},
						{
							path: '/settings/:tab',
							exact: true,
							component: lazy(() => import('views/Settings')),
						},
						{
							path: '/social-feed',
							exact: true,
							component: lazy(() => import('views/SocialFeed')),
						},
						{
							path: '/getting-started',
							exact: true,
							component: lazy(() => import('views/GettingStarted')),
						},
						{
							component: () => <Redirect to="/errors/error-404" />,
						},
					],
				},
			})
		}),
	},
];

export default routes;
